<template>
  <div class="animated fadeIn list-kiriman-gratis">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Tambah</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Ubah</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Hapus</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Ekspor
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl.Edisi/Kirim</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">s.d</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.kiriman_name" @change="tblData.kiriman_code=''" placeholder="Jenis Kiriman"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-prepend>
              <span class="pl-2 pt-2 pr-1">Kota Layanan</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.kota_name"
              @keyup.13.native="lkuKoranKotaShow=true"
              @change="tblData.kota_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

        </b-col>
        <b-col lg="6">
         <b-input-group>
            <b-input-group-prepend>
              <label>Nama Penerima</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
         <b-input-group>
            <b-input-group-prepend>
              <label>Target Penerima</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.linetype"
              :options="linetype"
              class="mb-1"
              :plain="true"
            >
              <template v-slot:first>
                <option :value="null" disabled>-- Pilih Target Campaign --</option>
              </template>
            </b-form-select>
            <b-input-group-append class="ml-2">
              <b-button class="btn btn-success ml-3 mr-1" size="sm" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary" size="sm"  @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter
              </b-button>
            </b-input-group-append>

          </b-input-group>                    
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(CustName)="data">{{data.item.CustCode}} | {{data.item.CustName}}</template>
        <template v-slot:cell(jurusan_code)="data">
          <span
            v-if="data.item.jurusan_code !== 'NULL'"
          >{{data.item.jurusan_code}} | {{data.item.jurusan_name}}</span>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group style="width: 200px;">
            <b-input-group-prepend class="mb-0">
              <span class="p-2">Limit per page</span>
            </b-input-group-prepend>
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:90px !important;"
            />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal
      v-model="lkuKoranKotaShow" size="lg"
      :hide-footer="true"
      title="List Kota"
      :centered="true"
    >
      <lku-kota @click="onSelectKota"></lku-kota>
    </b-modal>
    <b-modal v-model="lkuKoranKirimanCodeShow" size="lg" :hide-footer="true" title="Jenis Kiriman" :centered="true">
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman" crudfilter="gratis=1"></lku-koranjeniskiriman>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>
<style lang="scss">
  .list-kiriman-gratis {
      table {
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
}
</style>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import crud from "../../apis/crud";
import kirimangratisan from "../../apis/koran_kirim_gratis";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuKota from "../lookup/lkuKoranKota";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";

import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, lkuCustomerkoran, lkuKota, lkuKoranjeniskiriman },
  data() {
    return {
      // tglaktif: moment().subtract(5,'days').format('YYYY-MM-DD'),
      tglaktif: this.$store.state.user.tglkoran,
      uanguser: this.$store.state.user.matauang,
      showDelConfirm: false,
      horizontal: true,
      showFilter: false,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      terpilih: { customer_id: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        sortBy: null,
        sortDesc: false,
        koran: "1",
        linetype: null,
        kota_id: null,
        jurusan_id: null,
        tgl1: null,
        tgl2: null
      },
      pagination: false,      
      linetype: [],
      korankota: [],
      koranJrsList: [],
      tgl1: null,
      tgl2: null,
      lkuKoranCustShow: false,
      lkuKoranKotaShow: false,
      lkuKoranKirimanCodeShow: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "tanggal",
          label: "Tgl. Kirim",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "linename",
          label: "Target",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Penerima",
          sortable: true
        },
        {
          key: "jurusan_name",
          label: "Jurusan Kirim",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "gratis",
          label: "Jml.Kiriman Gratis",
          sortable: true
        },
        {
          key: "kota_name",
          label: "Kota Layanan",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales/AE",
          sortable: true
        }
      ];
      return fields;
    }
  },
  watch: {
    tgl1(val) {
      if (val !== null) this.tblData.tgl1 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl1 = null;
    },
    tgl2(val) {
      if (val !== null) this.tblData.tgl2 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl2 = null;
    }
  },
  created: async function() {
    const a = await crud.list({ tablename: "korancampaignlinetype" });
    this.linetype = a.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.linetype,
        text: `${el.linename}`
      });
      return newArr;
    }, []);

  },
  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.CustName = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectKota: function(_selected) {
      this.tblData.kota_id = _selected.kota_id;
      this.tblData.kota_name = _selected.kota_name;
      this.lkuKoranKotaShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_name = _selected.kiriman_name;
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },
    formatDate(val) {
      if (val !== "") {
        let date = new Date(val);
        return moment(date).format("DD MMMM YYYY");
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.kirimangratis) {
            this.tblData[key] = filter.kirimangratis[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.kirimangratis.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.kirimangratis;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await kirimangratisan.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await kirimangratisan.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },    

    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.CustName = '';
      this.tblData.customer_id = '';
      this.tblData.linetype = null;
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.kota_id = null;
      this.tblData.kota_name = null;
      this.tblData.jurusan_id = null;
      this.tblData.jurusan_name = null;
      this.tblData.kiriman_code = "";
      this.tblData.kiriman_name = "";

      this.refresh();
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','tgl1', 'tgl2', 'kota_id', 'kota_name', 'linetype', 'jurusan_id', 'jurusan_name', 'customer_id', 'CustName','kiriman_code','kiriman_name'];
      let filtered = false;
      const kirimangratis={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              kirimangratis[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          kirimangratis.page=this.tblData.page;
          kirimangratis.limit=this.tblData.limit;
          // console.log('Filter Kiriman Gratis: ', kirimangratis);
          const filter = this.$store.state.filter;
          filter.kirimangratis=kirimangratis;
          this.$store.commit("filter", filter);
      }
    },      
    rowEdit(record) {
      this.terpilih = record;
      this.edit();
    },
    // rowPrint(record) {
    //   this.rowClicked(record);
    //     this.print();        
    // },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },      

    add: function() {
      this.saveFilter();
      router.push({ name: "koran.kirimancampaignfrm" });
    },
    edit: function() {
      if (this.terpilih.kirimanKey) {
        if (moment(this.terpilih.tanggal).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);       
        // } else if (this.terpilih.campaignPsnKey) {
        //         toastr.error("Kiriman tdk berbayar ini tidak bisa direvisi dari menu ini", "ERROR MESSAGE",10000);       
        } else { 
          console.log('Terpilih kiriman gratis: ', this.terpilih.kirimanKey);

          this.saveFilter();
           router.push({
          name: "koran.kirimancampaignfrm",
          params: {
            kirimanKey: this.terpilih.kirimanKey
          }
        });
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.terpilih.kirimanKey) {
        if (moment(this.terpilih.tanggal).format("YYYY-MM-DD")<this.tglaktif) {
                toastr.error("Tanggal transaksi sudah CLOSED", "ERROR MESSAGE",10000);        
        // } else if (this.terpilih.campaignPsnKey) {
        //         toastr.error("Kiriman tdk berbayar ini tidak bisa dihapus dari menu ini", "ERROR MESSAGE",10000);       
        } else { 
          this.showDelConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await kirimangratisan.remove(this.terpilih);
        toastr.success("Delete record successfully");
        this.refresh();
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
      }
    },
    rowClicked(record, index) {
      // if (this.terpilih.customer_id == record.customer_id) {
      //   this.edit();
      // } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      // }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await kirimangratisan.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
      }
    },
    close() {
      router.push("home");
    }
  }
};
</script>